import React from 'react';
import LightboxStore from '../../../stores/lightbox_store';
import MapStore from '../../../stores/map_store';
import Map from '../../../../maps/map';
import FinderMapMarkerComponent from './finder_map_marker';
import FittingStationFinderConstants from '../../../constants/fitting_station_finder_constants';
import { getMap, setMap, resolveMapPromise } from '../../../helper/gmap';
import { isEqual, noop, cloneDeep } from '../../../../../lib/utilities';
import { getValue } from '../../../../utilities/local_storage';
import Translation from '../../translation/translation';
import MapActions from '../../../actions/map_actions';
import { ProductsStore } from '../../../stores/products_store';
import StationsActions from '../../../actions/fitting_station_actions';
import API from '../../../../API/api';
import { isNzStore } from '../../../../_views/configurator/common';


class FinderMapComponent extends React.Component {
    constructor(props) {
        super(props);

        this.update = false;
        this.state = {
            latLng: MapStore.getState().latLng,
            wheelAlignment: cloneDeep(this.props.wheelAlignment)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual({
            wheelAlignment: nextProps.wheelAlignment
        }, {
            wheelAlignment: this.state.wheelAlignment
        })) {
            this.update = true;
            this.setState({
                wheelAlignment: cloneDeep(nextProps.wheelAlignment),
            });
        }
    }

    componentDidMount() {
        var updateMapViewCallback;
        var $mapContainer = $(this.refs.mapContainer);

        this._setMap($mapContainer);

        const map = getMap();
        map?.map?.addListener('drag', () => {
            this.props.onMapLocationChanged(true);
        });

        updateMapViewCallback = this._updateMapView.bind(this, $mapContainer);
        LightboxStore.addListener(updateMapViewCallback);
        MapStore.addListener(() => {
            var mapStoreState = MapStore.getState();
            updateMapViewCallback();

            if (!isEqual(this.state.latLng, mapStoreState.latLng)) {
                this.setState({ latLng: mapStoreState.latLng }, () => {
                    getMap().setMapAddress(this.state.latLng);
                });
            }
        });

        $(window).on('resize', updateMapViewCallback);
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual({
            stations: this.props.stations,
            detailModeStation: this.props.detailModeStation,
            activeStation: this.props.activeStation,
            hoveredStation: this.props.hoveredStation,
            listMapView: this.props.listMapView,
            isMapLocationChanged: this.props.isMapLocationChanged
        }, {
            stations: nextProps.stations,
            detailModeStation: nextProps.detailModeStation,
            activeStation: nextProps.activeStation,
            hoveredStation: nextProps.hoveredStation,
            listMapView: nextProps.listMapView,
            isMapLocationChanged: nextProps.isMapLocationChanged
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hoveredStation !== this.props.hoveredStation && null !== this.props.hoveredStation) {
            this._scrollToHoveredStation();
        }

        if (
            prevProps.listMapView === FittingStationFinderConstants.LIST_VIEW && this.props.listMapView !== FittingStationFinderConstants.LIST_VIEW ||
            this.props.listMapView !== FittingStationFinderConstants.MAPLIST_VIEW && !!prevProps.detailModeStation && !this.props.detailModeStation
        ) {
            getMap().updateView();
        }
    }

    render() {
        var listMapView = this.props.listMapView;
        var listView = FittingStationFinderConstants.LIST_VIEW;
        var bothView = FittingStationFinderConstants.MAPLIST_VIEW;

        var showMap = listMapView === bothView || listMapView !== listView && !this.props.detailModeStation;
        var style = {
            display: showMap ? 'block' : 'none',
            width: this.props.listMapView !== FittingStationFinderConstants.MAPLIST_VIEW ? '100%' : '50%'
        };

        var stations = this._getStations();
        const latLng = getValue('latLng');
        return (
            <div className="finder-map" style={style}>
                <div className='slide-in-wrapper'>
                    <div className='slide-in' style={this.props.isMapLocationChanged ? { left: '0' } : { left: '-100%', height: '0' }}>
                        <div>
                            <button
                                className='fsf-map-search-btn'
                                onClick={(e) => this._setNewLocation(e)}
                            >
                                <Translation translationKey="search-this-area-text" />
                            </button>

                            <svg
                                className='fsf-map-search-btn fsf-map-current-location-btn'
                                onClick={(e) => this._setCurrentLocation(e)}
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="IconChangeColor" height="20" width="20">
                                <path d="M176 256C176 211.8 211.8 176 256 176C300.2 176 336 211.8 336 256C336 300.2 300.2 336 256 336C211.8 336 176 300.2 176 256zM256 0C273.7 0 288 14.33 288 32V66.65C368.4 80.14 431.9 143.6 445.3 224H480C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H445.3C431.9 368.4 368.4 431.9 288 445.3V480C288 497.7 273.7 512 256 512C238.3 512 224 497.7 224 480V445.3C143.6 431.9 80.14 368.4 66.65 288H32C14.33 288 0 273.7 0 256C0 238.3 14.33 224 32 224H66.65C80.14 143.6 143.6 80.14 224 66.65V32C224 14.33 238.3 0 256 0zM128 256C128 326.7 185.3 384 256 384C326.7 384 384 326.7 384 256C384 185.3 326.7 128 256 128C185.3 128 128 185.3 128 256z" id="mainIconPathAttribute" strokeWidth="0" stroke="#ff0000"></path>
                            </svg>
                        </div>

                        <div id="myProgress" className=''>
                            <div id="myBar"></div>
                        </div>
                    </div>
                </div>

                <div ref="mapContainer"
                    id="map-canvas"
                    onClick={() => this.props.onMapLocationChanged(true)}
                    className="loading fitting-station-finder__map"
                    data-longitude={latLng?.lng || '152.9823835'}
                    data-latitude={latLng?.lat || '-27.4412376'}
                />
                {stations}
            </div>
        );
    }

    async _setNewLocation(e, latLngObj) {
        e && e.preventDefault();
        const self = this;
        const elem = document.getElementById("myBar");
        elem.style.width = "0%";

        window.isCustomSearchClicked = true;
        const map = getMap();
        const latLng = {
            lat: latLngObj?.lat || map.getGoogleMap().center.lat(),
            lng: latLngObj?.lng || map.getGoogleMap().center.lng(),
        };
        const newLocation = map.formatLocation(latLng.lat, latLng.lng);
        MapActions.setLatLngAction(newLocation);
        const northEast = map.map.getBounds().getNorthEast();
        const southWest = map.map.getBounds().getSouthWest();

        let radius = this.calculateDistance(northEast.lat(), northEast.lng(), southWest.lat(), southWest.lng(), 'K') / 2;
        if (radius <= 20) {
            radius = 20;
            map.setZoom(11);
            map.currentZoomLevel = 11;
        }

        elem.style.width = "15%";
        const addressFromLatLng = await this._getPostcodeFromLatLng(latLng);
        elem.style.width = "30%";

        const products = ProductsStore.getState();
        await StationsActions.fetchStationsAction({
            postcode: addressFromLatLng && addressFromLatLng.postcode ? `${addressFromLatLng.postcode}, ${isNzStore(TYROOLA.globals.store) ? (addressFromLatLng.suburb || addressFromLatLng.city) : (addressFromLatLng.city || addressFromLatLng.suburb)}` : getValue('shippingPostcode') || '',
            latitude: latLng.lat,
            longitude: latLng.lng,
            radiusKm: radius,
        }, products);
        elem.style.width = "50%";

        let width = 50;
        let id = setInterval(frame, 10);
        function frame() {
            if (width >= 100) {
                clearInterval(id);
                elem.style.width = "0%";
                self.props.onMapLocationChanged(false);
            } else {
                width++;
                elem.style.width = width + "%";
            }
        }
    }

    /*  See https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates/60465578#60465578
        to calculate the distance between 2 coordinates
    */
    calculateDistance(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit == "K") { dist = dist * 1.609344 }
            if (unit == "N") { dist = dist * 0.8684 }
            return dist;
        }
    }

    async _getPostcodeFromLatLng(data) {
        try {
            const response = await API.GET({
                apiPath: FittingStationFinderConstants.POSTCODE_FROM_LAT_LNG_APIPATH,
                data: {
                    lat: data.lat,
                    long: data.lng,
                },
                dataType: 'json',
            });
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    _setCurrentLocation(e) {
        e && e.preventDefault();
        const self = this;
        window.isCustomSearchClicked = true;
        navigator.geolocation.getCurrentPosition(this.onSuccess.bind(this, self), this.onError.bind(this, self));
    }

    onSuccess(self, position) {
        const latLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
        const newLocation = getMap().formatLocation(latLng.lat, latLng.lng);
        MapActions.setLatLngAction(newLocation);
        self.props.onMapLocationChanged(true);
        this._setNewLocation(null, latLng);
    }

    onError(e) {
        console.log('GeoLocation Denied: ', e);
    }

    _getStations() {
        return this.props.stations.map((station) => {
            const isInDetailMode = this.props.detailModeStation === station.id;
            const isSelected = this.props.activeStation && this.props.activeStation.id === station.id;
            const isHovered = this.props.hoveredStation === station.id;
            const onClick = this.props.onDetailModeClick;
            const hasWheelAlignment2 = this.props.wheelAlignment.wheels2.indexOf(station.id) !== -1;
            const hasWheelAlignment4 = this.props.wheelAlignment.wheels4.indexOf(station.id) !== -1;
            const totals = this._getTotals(station, hasWheelAlignment2, hasWheelAlignment4);

            return (
                <FinderMapMarkerComponent
                    key={"marker-" + station.id}
                    data={station}
                    map={getMap()}
                    gMap={getMap().getGoogleMap()}
                    inDetailMode={isInDetailMode}
                    isSelected={isSelected}
                    isHovered={isHovered}
                    onDetailModeClick={onClick}
                    onListModeClick={this.props.onListModeClick}
                    onStationHover={this.props.onStationHover}
                    onStationHoverEnd={this.props.onStationHoverEnd}
                    totalCart={totals}
                />
            );
        });
    }

    _getTotals(station, hasWheelAlignment2, hasWheelAlignment4) {
        return hasWheelAlignment2 ?
            station.wheelAlignment.wheels_2_totals : hasWheelAlignment4 ?
                station.wheelAlignment.wheels_4_totals :
                station.totalCart;
    }

    _setMap($mapContainer) {
        var map = new Map($mapContainer);
        map.setDefaultCoordinates({
            latitude: parseFloat($mapContainer.data('latitude')),
            longitude: parseFloat($mapContainer.data('longitude'))
        });

        map.init(resolveMapPromise, false);
        setMap(map);
    }

    _scrollToHoveredStation() {

    }

    _updateMapView($mapContainer) {
        var lightboxStoreState = LightboxStore.getState();
        if (lightboxStoreState.visible && lightboxStoreState.activePage === 1 && $mapContainer.is(':visible')) {
            getMap().resize();
        }
    }
}

export default FinderMapComponent;
